import { IThunkActionCreator } from '../../types/store';

export interface ISavedFilter {
  id: number;
  name: string;
  value?: number | number[];
}

export interface ISavedFilterAdded {
  type: 'SavedFilterAdded';
  payload: ISavedFilter;
}

export interface ISavedFilterChanged {
  type: 'SavedFilterChanged';
  payload: ISavedFilter;
}

export interface ISavedFilterRemoved {
  type: 'SavedFilterRemoved';
  payload: ISavedFilter;
}

export interface IFitTagsInOneLineChanged {
  type: 'FitTagsInOneLineChanged';
  value: boolean;
}

export interface IAllSavedFiltersRemoved {
  type: 'AllSavedFiltersRemoved';
}

export type Action =
  ISavedFilterAdded | ISavedFilterChanged | ISavedFilterRemoved | IFitTagsInOneLineChanged | IAllSavedFiltersRemoved;

export function fitInOneLine(value: boolean): IFitTagsInOneLineChanged {
  return {
    type: 'FitTagsInOneLineChanged',
    value,
  };
}

export function addSavedFilter(payload: ISavedFilter): IThunkActionCreator {
  return dispatch => {
    dispatch<ISavedFilterAdded>({
      payload,
      type: 'SavedFilterAdded',
    });
  };
}

export function changeSavedFilter(payload: ISavedFilter): IThunkActionCreator {
  return dispatch => {
    dispatch<ISavedFilterChanged>({
      payload,
      type: 'SavedFilterChanged',
    });
  };
}

export const justRemoveSavedFilter = (payload: ISavedFilter): ISavedFilterRemoved => ({
  payload,
  type: 'SavedFilterRemoved',
});

export const removeAllSavedFilters = (): IAllSavedFiltersRemoved => ({ type: 'AllSavedFiltersRemoved' });
